export class BrMCommon {

    static showWaitWheel(container, noRelPos) {
        if (!container)
            console.error("Container is null");

        if (!(noRelPos && noRelPos === true))
            $(container).css("position", "relative");

        $(container).prepend("<div class='overlay'><div class='overlay-spinner'></div></div>");
    }

    static hideWaitWheel(container) {
        if (!container)
            console.error("Container is null");

        $(container).find(".overlay").remove();
    }

    static closestEl(el, tagName) {
        tagName = tagName.toLowerCase();

        while (el && el.parentNode) {
            el = el.parentNode;
            if (el.tagName && el.tagName.toLowerCase() === tagName) {
                return el;
            }
        }

        return null;
    }

    static onReady(callback) {
        if (callback && typeof callback === 'function') {
            if (!BrMCommon.isIE) {
                document.addEventListener("DOMContentLoaded", function () {
                    return callback();
                });
            } else {
                document.attachEvent("onreadystatechange", function () {
                    if (document.readyState === "complete") {
                        return callback();
                    }
                });
            }
        } else {
            console.error('The callback is not a function!');
        }
    }

    static get isIE() {
        return (!document.attachEvent || typeof document.attachEvent === "undefined" ? false : true);
    }

    static get browser() {
        let browser = {
            isChrome: false,
            isMozilla: false,
            isOpera: false,
            isIE: false,
            isEdge: false,
            isSafari: false
        };
        var sUsrAg = navigator.userAgent;
        if (sUsrAg.indexOf("Chrome") > -1) {
            browser.isChrome = true;
        } else if (sUsrAg.indexOf("Safari") > -1) {
            browser.isSafari = true;
        } else if (sUsrAg.indexOf("Opera") > -1) {
            browser.isOpera = true;
        } else if (sUsrAg.indexOf("Firefox") > -1) {
            browser.isMozilla = true;
        } else if (sUsrAg.indexOf("Trident") > -1) { //I hate IE
            browser.isIE = true;
        }

        let ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            browser.name = 'IE';
            browser.version = parseInt((tem[1] || ''));
        }
        else if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null) {
                if (tem[1] === 'Edge')
                    browser.isEdge = true;
                browser.name = tem[1].replace('OPR', 'Opera');
                browser.version = parseInt(tem[2]);
            }
            else {
                M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
                if ((tem = ua.match(/version\/(\d+)/i)) != null)
                    M.splice(1, 1, tem[1]);

                browser.name = M[0];
                browser.version = parseInt(M[1]);
            }
        }
        else {
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = ua.match(/version\/(\d+)/i)) != null)
                M.splice(1, 1, tem[1]);

            browser.name = M[0];
            browser.version = parseInt(M[1]);
        }

        //check cookies
        let cookieEnabled = (navigator.cookieEnabled) ? true : false
        if (typeof(navigator.cookieEnabled) === "undefined" && !cookieEnabled) {
            document.cookie = "testcookie"
            cookieEnabled = (document.cookie.indexOf("testcookie") != -1) ? true : false
        }
        browser.cookiesEnabled = cookieEnabled;

        return browser;
    }

    static getCleanObjectFromVue(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
}